import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const AppButton = ({
  children,
  label,
  icon,
  iconPosition = 'left',
  onClick,
  variant = 'primary',
  type = 'button',
  className = '',
  style = {},
  disabled = false,
  title = '',
  outline = false,
  ...rest
}) => {
  const buttonClass = outline
    ? `app-btn app-btn-${variant}-outline ${className}`
    : `app-btn app-btn-${variant} ${className}`;

  return (
   <Button
      type={type}
      disabled={disabled}
      onClick={onClick}
      color={variant}
      className={buttonClass}
      style={style}
      title={title}
      {...rest}
    >
      {icon && iconPosition === 'left' && icon}

      {(children || label) && (
        <span className={icon ? 'ms-1' : ''}>
          {children || label}
        </span>
      )}

      {icon && iconPosition === 'right' && (
        <span className={children || label ? 'ms-1' : ''}>
          {icon}
        </span>
      )}
    </Button>
  );
};

AppButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func,
  children: PropTypes.node,
  variant: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  outline: PropTypes.bool,
};

export default AppButton;